const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '')

export const resolveApiClientBaseUrl = (configuredUrl?: string): string => {
  const normalizedUrl = configuredUrl?.trim()

  if (normalizedUrl) {
    return `${trimTrailingSlash(normalizedUrl)}/api/v1`
  }

  return '/api/v1'
}

export const resolveApiBaseUrl = (configuredUrl?: string): string => {
  const normalizedUrl = configuredUrl?.trim()

  if (normalizedUrl) {
    return trimTrailingSlash(normalizedUrl)
  }

  return window.location.origin
}

export const buildApiUrl = (path: string, configuredUrl?: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${resolveApiBaseUrl(configuredUrl)}${normalizedPath}`
}

export const resolveRealtimeServerUrl = (
  configuredUrl?: string
): string | undefined => {
  const normalizedUrl = configuredUrl?.trim()
  return normalizedUrl ? trimTrailingSlash(normalizedUrl) : undefined
}
